export default {
  id: 'slack_promote_content_shares',
  title: 'Promote content shares',
  type: 'Direct / Channel',
  canSendToChannel: true,
  relations: [ 'MANY_CONTENT' ],
  description: 'Send up to 4 selected pieces of content to your employees so they can easily share them across their network.',
  body: {
    blocks: [
      {
        text: {
          text: '[[INPUT_INTRODUCTION_TEXT]]',
          type: 'mrkdwn'
        },
        type: 'section'
      },
      {
        type: 'blocks',
        key: 'BLOCK_CONTENT',
      }
    ]
  },
  blocks: {
    BLOCK_CONTENT: [
      {
        text: {
          text: '*{{CONTENT_[ID]_TITLE}}*',
          type: 'mrkdwn'
        },
        type: 'section'
      },
      {
        type: 'actions',
        elements: [
          {
            url: '{{CONTENT_[ID]_LINKEDIN_SHARE_LINK}}',
            text: {
              text: 'Share on LinkedIn',
              type: 'plain_text',
              emoji: true
            },
            type: 'button'
          }
        ]
      }
    ]
  },
  inputs: {
    INPUT_INTRODUCTION_TEXT: {
      label: 'Intro',
      placeholder: 'Share the following pieces of content with your network to win rewards! ...',
      defaultValue: 'Share the following pieces of content with your network to win rewards!',
      type: 'HTML'
    }
  }
};


// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/slack/picnic/promoteContentShares.js